const sumar = (resultados, campo) => resultados.reduce(
  (total, item) => total + (item[campo] || 0), 0,
);

/**
 * Calcula los totales globales de un conjunto de contratos del Tablero de Expedientes.
 * El porcentaje global es Sum(integrados) / Sum(documentosAplicables), nunca el promedio
 * de los porcentajes individuales por contrato.
 * @param {Array} resultados - contratos con documentosAplicables/integrados/faltantes/noAplicables
 * @returns {Object} totales
 */
const calcularTotalesGlobales = (resultados) => {
  const totalDocumentos = sumar(resultados, 'totalDocumentos');
  const integrados = sumar(resultados, 'integrados');
  const faltantes = sumar(resultados, 'faltantes');
  const noAplicables = sumar(resultados, 'noAplicables');
  const documentosAplicables = sumar(resultados, 'documentosAplicables');
  const porcentajeGlobal = documentosAplicables > 0
    ? Math.round(((integrados / documentosAplicables) * 100) * 100) / 100
    : 0;

  return {
    totalContratos: resultados.length,
    totalDocumentos,
    integrados,
    faltantes,
    noAplicables,
    documentosAplicables,
    porcentajeGlobal,
  };
};

export default calcularTotalesGlobales;
